import pushNotification from "../../../../src/components/push-notification";
import * as React from 'react';
export default {
  pushNotification,
  React
};